<app-navbar title="Kwaterunek">
	<div class="me-4">
		<select
			class="form-select"
			[ngModel]="service.destination"
			(ngModelChange)="destinationChange($event)"
			placeholder="Wybierz destynację"
		>
			<option [value]="destination.id" *ngFor="let destination of destinations">
				{{ destination.name }}
			</option>
		</select>
	</div>

	<div class="btn btn-light me-4" (click)="productsOpen()">Produktów: {{ service.productsSelected.length }}</div>

	<!--
	<button class="btn btn-light me-4" disabled>
		<mat-slide-toggle [(ngModel)]="show.terms">Terminy</mat-slide-toggle>
	</button>
	<button class="btn btn-light me-4" disabled>
		<mat-slide-toggle [(ngModel)]="show.subrooms"
			>Podrzędne</mat-slide-toggle
		>
	</button>
	-->

	<button class="btn btn-light me-4">
		<mat-slide-toggle [(ngModel)]="show.unassigned">Nieprzypisane</mat-slide-toggle>
	</button>
	<div class="btn btn-light me-4">
		<mat-slide-toggle [(ngModel)]="show.noname">No-Name</mat-slide-toggle>
	</div>
	<div class="btn btn-light me-4">
		<mat-slide-toggle (click)="loadAvability()">Podrzędne</mat-slide-toggle>
	</div>
	<a class="btn btn-primary" routerLink="/accommodation-file/generate">
		<i class="far fa-list-alt"></i>
		Generuj
	</a>
</app-navbar>

<app-accommodation-list-reservation (move)="reservationMoveStart($event)"></app-accommodation-list-reservation>

<div class="alert alert-danger" *ngIf="service.products.length === 0">Wybierz produkt z listy powyżej</div>

<div class="row row-header" *ngIf="service.products.length > 0">
	<div class="col product-sidebar">
		<!--
		<div class="form-floating mb-3">
			<input type="date" class="form-control" name="selectDate" id="selectDate" data-date-inline-picker="true"
				[(ngModel)]="service.date"
				(change)="setDate()"
			>
			<label for="selectDate">Data</label>
		</div>
-->
	</div>
	<div class="col" style="overflow: hidden">
		<app-accommodation-list-months
			[months]="months"
			[sticky]="true"
			(dateMove)="dateMove($event)"
		></app-accommodation-list-months>
		<div class="terms" *ngIf="show.terms">tutaj będą paski z terminami</div>
	</div>
</div>

<div class="buttons" *ngIf="moveButtons.length > 0">
	<div
		class="btn btn-primary"
		*ngFor="let button of moveButtons"
		[ngStyle]="button.style"
		(click)="moveHere(button)"
	></div>
</div>

<div class="row products" *ngFor="let product of service.products">
	<app-accommodation-list-product class="col" [product]="product" [show]="show"></app-accommodation-list-product>
	<div class="col checkers">
		<app-accommodation-list-availabilities
			[show]="show"
			[availabilities]="product.availabilities"
		></app-accommodation-list-availabilities>
		<app-accommodation-list-reservations
			identifier="reservations"
			[reservations]="product.reservations"
			(selected)="reservationSelected($event)"
		></app-accommodation-list-reservations>
	</div>
	<div *ngIf="show.unassigned && product.unassigned.length" class="row">
		<div class="col unassignedCart">
			<i class="fas fa-shopping-cart"></i>
		</div>
		<div class="col checkers">
			<app-accommodation-list-reservations
				identifier="unassigned"
				[reservations]="product.unassigned"
				(selected)="reservationSelected($event)"
			></app-accommodation-list-reservations>
			<div *ngFor="let _ of [].constructor(product.unassignedRows + 1)" class="fake"></div>
		</div>
	</div>
</div>
<div class="products-margin" *ngIf="show.noname"></div>
<div class="noname" *ngIf="show.noname">
	<div class="row">
		<div class="col product-sidebar">&nbsp;</div>
		<div class="col" style="overflow: hidden">
			<app-accommodation-list-months
				[months]="months"
				(dateMove)="dateMove($event)"
			></app-accommodation-list-months>
		</div>
	</div>
	<div class="row">
		<div class="col product-sidebar">&nbsp;</div>
		<div class="col checkers" style="margin-top: 40px">
			<app-accommodation-list-reservations
				identifier="nonames"
				[reservations]="service.nonames"
				(selected)="reservationSelected($event)"
			></app-accommodation-list-reservations>
			<div *ngFor="let _ of [].constructor(service.nonamesRows + 1)" class="fake"></div>
		</div>
	</div>
</div>
